module.exports = __webpack_public_path__ + "static/media/minnesota.d071a11e.svg";